module.exports = __webpack_public_path__ + "img/ic_img.3f8592ff.svg";